import { useContext, useEffect, useMemo, useState } from "react";
import { StyledMaterials } from "./Materials.styled";
import { Material } from "../../models/Material";
import { useMaterial } from "../../stores/useMaterial";
import { useProfile } from "../../stores/useProfile";
import {
  Box,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { LanguageContext } from "../../globals/LanguageContext";
import { Package, QrCodeIcon, Stack, X } from "@phosphor-icons/react";
import { DarkOverlay } from "../../components/darkOverlay/DarkOverlay";
import { CrateMenu } from "../../components/crateMenu/CrateMenu";
import { MaterialTable } from "../../components/materialTable/MaterialTable";
import { CrateList } from "../../components/crateList/CrateList";

export const Materials = () => {
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const [filterText, setFilterText] = useState<string>("");
  const [materials, setMaterials] = useState<Material[]>([]);
  const { dictionary } = useContext(LanguageContext);
  const { fetchMaterials } = useMaterial();
  const { user } = useProfile();
  const [selectedPage, setSelectedPage] = useState("stack");

  const filterItems = useMemo(() => {
    const searchWords = filterText.toLowerCase().split(/\s+/);

    const filteredArray = materials.filter((item) => {
      const lowerName = item.name.toLowerCase();
      const lowerBrand = item.brand.toLowerCase();

      return searchWords.every(
        (word) => lowerName.includes(word) || lowerBrand.includes(word)
      );
    });

    return filteredArray.reverse();
  }, [filterText, materials]);

  const UpdateItems = async () => {
    if (!user) return;
    const res = await fetchMaterials(user);

    if (res) setMaterials(res);
  };

  useEffect(() => {
    UpdateItems();
  }, [user]);

  return (
    <StyledMaterials>
      <DarkOverlay
        opened={darkOverlayOpened}
        component={<CrateMenu />}
        onClose={() => {
          setDarkOverlayOpened(false);
        }}
      />
      <Typography variant="h1">{dictionary.pages.materials.title}</Typography>
      <Box className="filterBar">
        <TextField
          variant="outlined"
          placeholder={dictionary.pages.materials.searchinput}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <Box className="actionButtons">
          <ToggleButtonGroup
            value={selectedPage}
            exclusive
            onChange={(_, newValue) => setSelectedPage(newValue)}
            aria-label="icon toggle group">
            <ToggleButton value="stack" aria-label="stack">
              <Stack size={28} />
            </ToggleButton>
            <ToggleButton value="package" aria-label="package">
              <Package size={28} />
            </ToggleButton>
          </ToggleButtonGroup>
          <Button
            onClick={() => setDarkOverlayOpened(true)}
            className="qrButton">
            <QrCodeIcon size={32} />
          </Button>
        </Box>
      </Box>

      {selectedPage === "stack" && (
        <MaterialTable
          filteredMaterials={filterItems}
          onSave={UpdateItems}
        />
      )}

      {selectedPage === "package" && <CrateList />}
    </StyledMaterials>
  );
};
